import {
  AnyAction,
  ListenerEffectAPI,
  PayloadAction,
  ThunkDispatch,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { FiltersPayloadModel } from '../../shared/models/filters-payload.model';
import { CampaignFilters } from '../models/campaign-filters.model';
import { CampaignsHeaderAndPaginationFilters } from '../store/slices/models/campaigns-header-and-pagination-filters.model';
import { getCampaigns } from '../thunks/get-campaigns.thunk';
import { CampaignsFilterListenerEffectModel } from './models/campaigns-filter-listener-effect.model';

export const CampaignsFilterListenerEffect: CampaignsFilterListenerEffectModel =
  (
    action: AnyAction,
    api: ListenerEffectAPI<
      AppRootState,
      ThunkDispatch<AppRootState, undefined, AnyAction>,
      unknown
    >
  ): void => {
    const currentAction = action as PayloadAction<
      FiltersPayloadModel<CampaignFilters>
    >;

    if (currentAction.payload?.property !== 'name') {
      const filters: Partial<CampaignsHeaderAndPaginationFilters> =
        api.getState().campaignsFeature.campaigns.filters;
      api.dispatch(getCampaigns(filters));
    }
  };
